import React from 'react';
import { ArrowUpRight } from 'lucide-react';

const hubs = [
  {
    kicker: 'GLOBAL HEADQUARTERS', kickerAmber: true, region: 'UAE', name: 'Abu Dhabi',
    desc: 'Global headquarters and core GCC market. From Abu Dhabi, Frontier partners directly with sovereign wealth funds, institutional investors, and corporate venture capital leaders—deploying sovereign enclaves at the center of global capital flows.',
    footLeft: 'Sovereign & Corporate VC', footRight: 'Lic. CN-6580462', footRightAmber: true,
  },
  {
    kicker: 'PRIMARY MARKET', region: 'US', name: 'New York',
    desc: 'Frontier’s primary transaction market. Grounded in two decades of advisory and technical due diligence for leading US private equity funds, corporate M&A desks, and TMT sponsors.',
    footLeft: 'US Buyout Desks', footRight: 'TMT Diligence',
  },
  {
    kicker: 'EUROPEAN GATEWAY', region: 'EUROPE', name: 'Luxembourg',
    desc: 'Strategic bridgehead into Western European private markets. Anchored by Dr. Bharat Madan, driving continental private equity origination, cross-border alliances, and fund-level transaction sprints.',
    footLeft: 'Continental Desk', footRight: 'Cross-Border M&A',
  },
  {
    kicker: 'SYSTEMS FOUNDRY', region: 'INDIA', name: 'Bengaluru',
    desc: 'The core engineering foundry of Frontier. Drawing on elite systems and algorithmic engineering talent to build Deal OS™, deterministic valuation runtimes, and air-gapped transaction memory graphs.',
    footLeft: 'Core Systems Lab', footRight: 'Multi-Agent R&D',
  },
];

// Section 5 — Global footprint & capital corridors + closing CTA.
export const FootprintSection = ({ onOpenBriefing }) => (
  <section className="py-24 sm:py-32 px-6 sm:px-10 lg:px-16 bg-[#FBFBFB] border-b border-stone-200/80">
    <div id="footprint" className="scroll-mt-20 w-full max-w-[1600px] mx-auto">

      <div className="max-w-3xl mb-14 sm:mb-20">
        <span className="mono text-[10px] uppercase tracking-[0.2em] text-[#F58220] font-semibold block mb-2.5">GLOBAL FOOTPRINT · CAPITAL CORRIDORS</span>
        <h2 className="text-3xl sm:text-5xl font-medium text-stone-950 tracking-tight mb-4">Headquartered in Abu Dhabi. Built on US dealcraft.</h2>
        <div className="space-y-3 text-stone-700 text-base sm:text-lg leading-relaxed font-sans">
          <p>Frontier is headquartered in Abu Dhabi, operating at the direct nexus of sovereign investment, regional corporate venture capital, and tier-one AI infrastructure.</p>
          <p>Rooted in two decades of advisory and diligence for leading US private equity firms, our platform bridges institutional transactions across North America, the GCC, Western Europe, and East Asia.</p>
        </div>
      </div>

      {/* 4-hub grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-7 mb-16 sm:mb-20 items-stretch">
        {hubs.map((h) => (
          <div key={h.name} className="bg-white rounded-3xl p-7 sm:p-8 border border-stone-200/90 shadow-sm flex flex-col justify-between group hover:border-[#F58220]/40 transition-colors duration-300">
            <div>
              <div className="flex items-center justify-between mb-3">
                <span className={`text-[10px] mono font-bold uppercase tracking-wider ${h.kickerAmber ? 'text-[#F58220]' : 'text-stone-500'}`}>{h.kicker}</span>
                <span className="mono text-[10px] text-stone-400">{h.region}</span>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-stone-950 tracking-tight mb-3">{h.name}</h3>
              <p className="text-xs sm:text-[13px] text-stone-600 leading-relaxed font-sans mb-4">{h.desc}</p>
            </div>
            <div className="pt-4 border-t border-stone-100 flex items-center justify-between mono text-[10px] text-stone-500">
              <span>{h.footLeft}</span>
              <span className={h.footRightAmber ? 'text-[#F58220] font-semibold' : 'text-stone-800 font-semibold'}>{h.footRight}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Active corridors strip */}
      <div className="mb-14 px-2 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-stone-500 border-t border-stone-200/80 pt-6 font-mono">
        <div className="flex items-center gap-2">
          <span className="w-1.5 h-1.5 rounded-full bg-[#F58220]" />
          <span><strong>Active Corridors:</strong> North America (US Buyout) · Western Europe (DACH & Benelux) · GCC (Abu Dhabi & Dubai) · East Asia (Seoul & Tokyo).</span>
        </div>
        <div className="text-[11px] text-stone-400">Timezones: EST (US) · GMT+1 (Europe) · GMT+4 (HQ) · GMT+5:30 (Foundry)</div>
      </div>

      {/* Closing CTA */}
      <div className="pt-16 sm:pt-24 lg:pt-32 pb-6 sm:pb-10 text-center max-w-5xl mx-auto">
        <h2 className="text-4xl sm:text-6xl lg:text-7xl font-bold tracking-tight text-stone-950 leading-[1.08] mb-8 sm:mb-10">Bring Frontier to your next mandate.</h2>
        <div className="flex justify-center">
          <button onClick={() => onOpenBriefing('Mandate Briefing')} className="inline-flex items-center gap-2.5 px-8 py-4 rounded-full text-xs sm:text-sm font-semibold bg-[#090E1A] text-white hover:bg-black hover:scale-[1.02] transition-all shadow-sm">
            <span>Request Briefing</span>
            <ArrowUpRight className="w-4 h-4 text-[#F58220]" />
          </button>
        </div>
      </div>

    </div>
  </section>
);
